import { dbIndex } from "../../../constants/dbs";
import calcCodingImpact from "../../../helpers/calcCodingImpact";
import {
  pathogenicityIndex,
  impactColorIndex,
  impactIndex,
} from "../../../constants/pathogenicity";
import castArray from "../../../../../common/helpers/castArray";

class PathogenicityDetails {
  constructor(data, variant) {
    const impact = calcCodingImpact(data.coding_impact);
    this.pathoIndex = pathogenicityIndex[data.acmg_class];
    this.codingImpactIndex = impactIndex[impact];
    this.codingImpactColorIndex = impactColorIndex[impact];
    this.sourceIndex = dbIndex[data.source];
    this.variant = variant;
    this.id = `${variant.id}-${this.pathoIndex}-${this.codingImpactIndex}`;
    this.hgvs = data.hgvs;
    this.transcriptId = data.transcriptId;
    this.codon = data.codon;
    this.gene = data.gene_symbol;
    this.mainData = data.main_data;
    this.reviewStars = data.review_stars;
    this.disease = data.disease;
    this.conflict = data.conflict;
    this.count = data.count || 1;
    const pubs = data.pub_med_references
      ? castArray(data.pub_med_references)
      : [];
    this.pubmedIds = Array.from(new Set(pubs).values());
  }

  get region() {
    return this.variant.region;
  }
}

export default PathogenicityDetails;
